// src/App.jsx
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Layout from "./components/ui/Layout";

import Home from "./pages/home/Home";

import NotFoundPage from "./pages/error/NotFoundPage";

import { Toaster } from "sonner";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },

      // 404 Page
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-start" richColors />
    </>
  );
}

export default App;
